export * from './DetailsNavTabs';
